/* eslint-disable @typescript-eslint/no-explicit-any */
import { IPriceResponse } from '@/types/common';
import axios, { AxiosResponse } from 'axios';

export class BinanceService {
  static readonly EXCHANGE_INFO_ENDPOINT: string = 'https://api.binance.com/api/v3/exchangeInfo';
  static readonly TICKER_PRICE_ENDPOINT: string = 'https://api.binance.com/api/v3/ticker/price';

  public static async getAllCoins(): Promise<string[]> {
    try {
      const res = await axios.get(BinanceService.EXCHANGE_INFO_ENDPOINT);
      const symbols = res.data.symbols;

      const coinSet = new Set<string>();
      symbols.forEach((symbol: any) => {
        coinSet.add(symbol.baseAsset);
        coinSet.add(symbol.quoteAsset);
      });

      return Array.from(coinSet).sort();
    } catch (error) {
      console.error('Error fetching exchange info:', error);
      throw new Error('Failed to fetch exchange info');
    }
  }

  public static async getAllPairCoins(): Promise<string[]> {
    try {
      const res = await axios.get(BinanceService.EXCHANGE_INFO_ENDPOINT);
      const symbols = res.data.symbols;

      return symbols
        .filter((s: any) => s.quoteAsset === 'USDC')
        .map((s: any) => ({
          content: `${s.baseAsset}/${s.quoteAsset}`,
          value: `${s.baseAsset}/${s.quoteAsset}`
        }));

    } catch (error) {
      console.error('Error fetching exchange info:', error);
      throw new Error('Failed to fetch exchange info');
    }
  }

  public static async getPairPrice(params: any): Promise<IPriceResponse> {
    try {
      const res: AxiosResponse<IPriceResponse> = await axios.get(BinanceService.TICKER_PRICE_ENDPOINT, { params });
      return res.data;
    } catch (error) {
      console.error('Error fetching exchange info:', error);
      throw new Error('Failed to fetch exchange info');
    }
  }
}
